import { DecoratorNode, LexicalEditor, LexicalNode, NodeKey } from 'lexical';
import { TemplateCustomPlaceholder } from 'src/components/pages/conversations/components/general/lexical-editor/nodes/template-placeholders-nodes/create-placeholders/template-custom-placeholder';
import { PlaceholderNode } from 'src/components/pages/conversations/components/general/lexical-editor/nodes/template-placeholders-nodes/shared';

export type SerializedCreateTemplateCustomPlaceholderNode = {
  label: string;
  type: 'template-custom-placeholder';
  version: 1;
  description?: string;
};

export const $createTemplateCustomPlaceholderNode = (
  label: string,
  description?: string,
): CreateTemplateCustomPlaceholderNode => {
  return new CreateTemplateCustomPlaceholderNode(label, description);
};

export class CreateTemplateCustomPlaceholderNode extends DecoratorNode<JSX.Element> {
  __label: string;
  __description: string | undefined;

  constructor(label: string, description?: string, key?: NodeKey) {
    super(key);

    this.__label = label.replace(':', ' ');
    this.__description = description;
  }

  static getType(): string {
    return 'template-custom-placeholder';
  }

  static clone(
    node: CreateTemplateCustomPlaceholderNode,
  ): CreateTemplateCustomPlaceholderNode {
    return new CreateTemplateCustomPlaceholderNode(
      node.label,
      node.description,
      node.__key,
    );
  }

  get label() {
    return this.__label;
  }

  get description() {
    return this.__description;
  }

  createDOM(): HTMLElement {
    const span = document.createElement('span');

    return span;
  }

  updateDOM(): boolean {
    return true;
  }

  getTextContent() {
    return `{{${this.label}:${this.getKey()}}}`;
  }

  getDisplayTextContent() {
    return `{{${this.label}}}`;
  }

  isKeyboardSelectable(): boolean {
    return false;
  }

  decorate(editor: LexicalEditor) {
    return (
      <TemplateCustomPlaceholder
        label={this.label}
        description={this.description}
        onSubmit={(label, description) => {
          editor.update(() => {
            const writable = this.getWritable();

            writable.__label = label.replaceAll(':', ' ');
            writable.__description = description;
          });
        }}
        onRemove={() => {
          editor.update(() => {
            const writable = this.getWritable();

            writable.remove();
          });
        }}
      >
        <PlaceholderNode data-lgg-id="create-custom-placeholder-node">
          {this.getDisplayTextContent()}
        </PlaceholderNode>
      </TemplateCustomPlaceholder>
    );
  }

  static importJSON(
    serializedNode: SerializedCreateTemplateCustomPlaceholderNode,
  ): LexicalNode {
    return new CreateTemplateCustomPlaceholderNode(
      serializedNode.label,
      serializedNode.description,
    );
  }

  exportJSON(): SerializedCreateTemplateCustomPlaceholderNode {
    return {
      ...super.exportJSON(),
      type: 'template-custom-placeholder',
      label: this.label,
      description: this.description,
      version: 1,
    };
  }
}
